module.exports = __webpack_public_path__ + "img/classic-fm.9807a1cd.png";